// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@ces/Overrides/Widgets/Header/SearchInput";
import Search from "@ces/XDL/Icons/Search";
import { color, xScreen } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

searchInputStyles.input = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            max-width: 884px;
            &&&& button,
            &&&& ${IconWrapper} {
                width: 34px;
                height: 34px;
                top: 0;
                right: 1px;
            }
        `,
        inputSelect: css`
            height: 34px;
        `,
    },

    iconProps: {
        src: Search,
        css: css`
            &,
            svg {
                width: 14px;
                height: 14px;
            }
        `,
    },
    css: css`
        &&& {
            border-radius: 17px;
            padding-inline: 13px;
        }
    `,
};

searchInputStyles.tippyPopup = {
    main: {
        css: css`
            &.tippy-box {
                border-top: 0;
                &:before {
                    content: "";
                    width: 8px;
                    height: 5px;
                    position: absolute;
                    top: -3px;
                    left: -1px;
                    border: 1px solid ${color("common.border")};
                    border-radius: 2px 0 0 0;
                    border-right: 0;
                    border-bottom: 0;
                    background: transparent;
                    ${xScreen("lte", "md")} {
                        border: none;
                    }
                }
                &:after {
                    content: "";
                    width: 12px;
                    height: 5px;
                    position: absolute;
                    top: -3px;
                    right: -1px;
                    border: 1px solid ${color("common.border")};
                    border-radius: 0 2px 0 0;
                    border-left: 0;
                    border-bottom: 0;
                    background: transparent;
                    ${xScreen("lte", "md")} {
                        border: none;
                    }
                }
                &:has(.content-wrapper:empty) {
                    display: none;
                }
                border-radius: 2px;
                ${xScreen("lte", "md")} {
                    border: none;
                }
                > .tippy-content {
                    padding: 0;
                    max-height: none;
                    overflow: hidden;
                }
            }
        `,
    },
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        ${xScreen("lte", 1260)} {
            width: auto;
        }
    `,
};
